"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Value = exports.TypeCompiler = exports.TypeCheck = exports.APIStateT = exports.APIEmailT = exports.APITimeT = exports.NumericBoolT = exports.APINumericBoolT = exports.APIRecordT = exports.NumericEnumT = exports.StringEnumT = exports.NumberT = exports.APIMaybeT = exports.OptionalT = exports.NullableT = void 0;
const tBox = __importStar(require("@sinclair/typebox"));
const compiler_1 = require("@sinclair/typebox/compiler");
Object.defineProperty(exports, "TypeCheck", { enumerable: true, get: function () { return compiler_1.TypeCheck; } });
Object.defineProperty(exports, "TypeCompiler", { enumerable: true, get: function () { return compiler_1.TypeCompiler; } });
const tBoxValue = __importStar(require("@sinclair/typebox/value"));
exports.Value = tBoxValue;
const omit_1 = __importDefault(require("lodash/omit"));
const some_1 = __importDefault(require("lodash/some"));
const meta_types_1 = require("./meta-types");
tBox.FormatRegistry.Set('date', value => {
    if (typeof value !== 'string') {
        return false;
    }
    const split = value.split('-');
    if (split.length !== 3) {
        return false;
    }
    if (split[0]?.length !== 4 || split[1]?.length !== 2 || split[2]?.length !== 2) {
        return false;
    }
    if ((0, some_1.default)(split, part => Number.isNaN(Number(part)))) {
        return false;
    }
    return true;
});
tBox.FormatRegistry.Set('time', value => {
    if (typeof value !== 'string') {
        return false;
    }
    let split = value.split(':');
    if (split.length !== 2) {
        if (split.length === 3) {
            split = split.slice(0, 2);
        }
        else {
            return false;
        }
    }
    if ((0, some_1.default)(split, part => Number.isNaN(Number(part)))) {
        return false;
    }
    return true;
});
tBox.FormatRegistry.Set('date-time', value => {
    if (typeof value !== 'string') {
        return false;
    }
    let split = value.split('T');
    if (split.length !== 2) {
        split = value.split(' ');
        if (split.length !== 2) {
            return false;
        }
    }
    if (!tBox.FormatRegistry.Get('date')?.(split[0] ?? '')) {
        return false;
    }
    if (!tBox.FormatRegistry.Get('time')?.(split[1] ?? '')) {
        return false;
    }
    return true;
});
tBox.TypeRegistry.Set('APINullable', (schema, value) => schema[meta_types_1.OriginalSchemaSymbol].Check(value));
tBox.TypeRegistry.Set('NumericBool', (_schema, value) => value === 1 || value === 0 || value === true || value === false);
const NullableT = (schema) => {
    const unionType = tBox.Type.Union([tBox.Type.Null(), schema]);
    const compiledSchema = compiler_1.TypeCompiler.Compile(unionType);
    return tBox
        .Transform(tBox.Type.Unsafe({
        ...(0, omit_1.default)(schema, Symbol.for('TypeBox.Transform')),
        [tBox.Kind]: 'APINullable',
        nullable: true,
        [meta_types_1.OriginalSchemaSymbol]: compiledSchema,
    }))
        .Decode((value) => compiledSchema.Decode(value))
        .Encode((value) => compiledSchema.Encode(value));
};
exports.NullableT = NullableT;
const OptionalT = (schema) => tBox.Type.Optional(schema);
exports.OptionalT = OptionalT;
const APIMaybeT = (schema) => tBox.Type.Optional((0, exports.NullableT)(schema));
exports.APIMaybeT = APIMaybeT;
const NumberT = (description) => {
    const schema = tBox.Type.Number();
    return tBox.Type.Unsafe({
        ...schema,
        ...(typeof description === 'string' ? { description } : description),
    });
};
exports.NumberT = NumberT;
const StringEnumT = (values, description) => tBox.Type.Unsafe({
    type: 'string',
    enum: values,
    description,
    [tBox.Kind]: 'String',
});
exports.StringEnumT = StringEnumT;
const NumericEnumT = (values, description) => tBox.Type.Unsafe((0, exports.NumberT)({ description, enum: values }));
exports.NumericEnumT = NumericEnumT;
const APIRecordT = (schema, description) => {
    const compiledSchema = compiler_1.TypeCompiler.Compile(tBox.Type.Record(tBox.Type.Number(), schema));
    return tBox
        .Transform(tBox.Type.Unsafe({
        type: 'object',
        properties: {},
        additionalProperties: schema,
        [tBox.Kind]: 'Object',
        description,
    }))
        .Decode((value) => compiledSchema.Decode(value))
        .Encode((value) => compiledSchema.Encode(value));
};
exports.APIRecordT = APIRecordT;
const APINumericBoolSchema = {
    [tBox.Kind]: 'NumericBool',
    oneOf: [
        {
            type: 'boolean',
        },
        {
            type: 'number',
            enum: [0, 1],
        },
    ],
};
const APINumericBoolT = (description) => tBox.Type.Transform(tBox.Type.Unsafe({
    ...APINumericBoolSchema,
    description,
}))
    .Decode(value => (value ? 1 : 0))
    .Encode(value => {
    if (typeof value === 'number') {
        return value === 1;
    }
    return value;
});
exports.APINumericBoolT = APINumericBoolT;
const NumericBoolT = (description) => tBox.Type.Transform(tBox.Type.Unsafe({
    ...APINumericBoolSchema,
    description,
}))
    .Decode((value) => {
    if (value !== 1 && value !== 0) {
        throw new Error(`Invalid numeric bool type: ${value}`);
    }
    return value === 1;
})
    .Encode((value) => (value ? 1 : 0));
exports.NumericBoolT = NumericBoolT;
exports.APITimeT = tBox.Type.String({ format: 'time' });
exports.APIEmailT = tBox.Type.String({ format: 'email' });
exports.APIStateT = (0, exports.StringEnumT)([
    'ACT',
    'NSW',
    'NT',
    'QLD',
    'SA',
    'TAS',
    'VIC',
    'WA',
]);
__exportStar(require("@sinclair/typebox"), exports);
//# sourceMappingURL=typebox.js.map